<template>
  <div
    ref="kt_modal_softwarehouses_consultar"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_softwarehouses_consultar"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-body p-0">
          <ConsultarSoftwareHouse
            ref="ConsultarSoftwareHouse"
            :modal="true"
            @selecionarSoftwareHouse="selecionarSoftwareHouse"
            @fecharSoftwareHouse="modalConsultarSoftwareHouse"
          ></ConsultarSoftwareHouse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConsultarSoftwareHouse from "@/views/softwarehouse/Consultar.vue";
import { hideModal } from "@/core/helpers/dom";

export default {
  emits: ["selecionarSoftwareHouse", "exibirModalSoftwareHouse"],
  components: {
    ConsultarSoftwareHouse,
  },
  methods: {
    modalConsultarSoftwareHouse(exibir) {
      if (exibir === false) {
        this.$emit("exibirModalSoftwareHouse", false);
      }
    },
    selecionarSoftwareHouse(softwareHouse) {
      this.$emit("selecionarSoftwareHouse", softwareHouse);
      this.modalConsultarSoftwareHouse(false);
      hideModal(this.$refs.kt_modal_softwarehouses_consultar);
    },
  },
  data() {
    return {};
  },
};
</script>

<style></style>
